import { useCallback, useRef } from 'react';

import {
	type AnalyticsEventAttributes,
	useAnalyticsEvents,
} from '@atlaskit/teams-app-internal-analytics';

import { getPageTime } from '../utils/performance';

export const useAnalyticsEventsWithDuration = (): (<K extends keyof AnalyticsEventAttributes>(
	eventKey: K,
	generator: (duration: number) => AnalyticsEventAttributes[K],
) => void) => {
	const { fireEvent } = useAnalyticsEvents();
	const openTimeRef = useRef(getPageTime());

	const fireAnalyticsWithDuration = useCallback(
		<K extends keyof AnalyticsEventAttributes>(
			eventKey: K,
			generator: (duration: number) => AnalyticsEventAttributes[K],
		) => {
			const duration = getPageTime() - openTimeRef.current;
			const attributes = generator(duration);
			fireEvent(eventKey, attributes);
		},
		[fireEvent],
	);

	return fireAnalyticsWithDuration;
};
